/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { PAGE_SIZE, MAX_STORIES, SCROLL_OFFSET } from "../constants";
import { debounce } from "../utils/debounce";

export const useInfiniteScroll = () => {
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);

  const handleScroll = debounce(() => {
    if (
      document.documentElement.offsetHeight - SCROLL_OFFSET >=
        window.innerHeight + document.documentElement.scrollTop ||
      loading
    ) {
      return false;
    }

    setLoading(true);
  }, 300);

  useEffect(() => {
    if (!loading) return;

    if (pageSize + PAGE_SIZE >= MAX_STORIES) {
      setPageSize((pageSize) => MAX_STORIES);
    } else {
      setPageSize((pageSize) => pageSize + PAGE_SIZE);
    }

    setLoading(false);
  }, [loading]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return { pageSize };
};
